import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers';

const withAuthentication = (Component) => {
  const AuthenticatedComponent = () => {
    const { isAuthenticated, isLoading } = useAuth();
    const { pathname, search } = useLocation();

    if (isLoading) return null;

    if (!isAuthenticated()) {
      // Store the IntendedURL in sessionStorage to
      // preserve it before login redirect
      sessionStorage.setItem('IntendedURL', `${pathname}${search}`);
      return <Navigate to='/auth/login' />;
    }

    return <Component />;
  };

  return <AuthenticatedComponent />;
};

export { withAuthentication };
